import { useLinkGroups, type LinkTarget } from "@helm/core";
import { WatchlistView } from "../sidebar/WatchlistView";

/**
 * Watchlist module (also the mobile Markets tab). Since 2026-09-28 it shows the user's synced
 * watchlists (`watchlist/main`, the same lists as the right sidebar; sidebar/WatchlistView.tsx):
 * list switcher, sections, flags, sort, drag to reorder. The old fixed "Futures" list is every new
 * user's first list, so nothing moved. Chg / Vol are measured from the first print received until
 * the gateway streams `SessionStats` (docs/PLAN.md TODO), and say so. Selecting a row retargets
 * the module's link group (the sidebar's watchlist targets the active chart instead).
 */
export function Watchlist({ link }: { link: LinkTarget }): React.JSX.Element {
  const setSymbol = useLinkGroups((s) => s.setSymbol);
  const active = useLinkGroups((s) => (link === "unlinked" ? null : s.groups[link].symbol));
  return (
    <WatchlistView
      compact
      selected={active}
      onPick={
        link === "unlinked"
          ? null
          : (s) => {
              setSymbol(link, s);
            }
      }
      pickHint={
        link === "unlinked"
          ? "Link this watchlist to a group to retarget widgets"
          : `Show in the ${link} group`
      }
    />
  );
}
